import { Security } from '../../proto/generated/candle-data-depot-common';
import { OptionChainProto } from '../../proto/generated/candle-data-depot-option-chain'
import { exchangeToJSON } from '../../proto/generated/common';
import { CalculateMarginResponse, MarginFromBrokerRequest } from '../../proto/generated/order';
import api from './axiosClient'

export interface GetHistoricOptionChainRequest {
  security: Security
  referenceTimestamp: number
}

export const getHistoricalOptionChain = (req: GetHistoricOptionChainRequest): Promise<OptionChainProto> => {
    return new Promise((resolve, reject) => {
        const url = `/simulator/option-chain`
        api.get(url, {
            headers: {
                'Accept': 'application/x-protobuf'
            },
            responseType: 'arraybuffer',
            params: {
                securityCode: req.security.code,
                exchange: exchangeToJSON(req.security.exchange),
                timestamp: req.referenceTimestamp
            }
        }).then(async (response) => {
            if (!response || !response.data) {
                reject(new Error('No data received'))
                return;
            }
            const decodedData = OptionChainProto.decode(new Uint8Array(response.data))
            resolve(decodedData)
        }).catch((error) => {
            reject(error)
        })
    })
}


// export const getSimulatorMargin = (req: MarginFromBrokerRequest): Promise<CalculateMarginResponse> => {
//     return new Promise((resolve, reject) => {
//         const url = `/simulator/margin`
//         api.post(url, JSON.stringify(req), {
//             headers: {
//                 'Accept': 'application/x-protobuf'
//             },
//             responseType: 'arraybuffer'
//         }).then(async (response) => {
//             if (!response || !response.data) {
//                 reject(new Error('No data received'))
//                 return;
//             }
//             const decodedData = CalculateMarginResponse.decode(new Uint8Array(response.data))
//             resolve(decodedData)
//         }).catch((error) => {
//             reject(error)
//         })
//     })
// }